import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: () => import('@/views/HomePage.vue')
    },
    {
        path: '/professor',
        component: () => import('@/views/professor/ProfessorLayout.vue'),
        children: [
            {
                path: '',  // 空路径会重定向到list
                redirect: '/professor/list'
            },
            {
                path: 'list',
                name: 'ProfessorList',
                component: () => import('@/views/professor/ProfessorList.vue')
            },
            {
                path: 'select-school',
                name: 'SchoolSelect',
                component: () => import('@/views/professor/SchoolSelect.vue')
            },
            {
                path: 'select-department',
                name: 'DepartmentSelect',
                component: () => import('@/views/professor/DepartmentSelect.vue')
            },
            {
                path: 'detail/:id',
                name: 'ProfessorDetail',
                component: () => import('@/views/professor/ProfessorDetail.vue')
            }
        ]
    },
    {
        path: '/square',
        name: 'MessageBoard',
        component: () => import('@/views/MessageBoard.vue'),
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/auth/Login.vue')
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/auth/Register.vue')
    },
    {
        path: '/profile',
        name: 'UserProfile',
        component: () => import('@/views/profile/UserProfile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/posts/create/:professorId',
        name: 'CreatePost',
        component: () => import('@/views/post/CreatePost.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/post/:postId/comments',
        name: 'PostComments',
        component: () => import('@/views/post/PostComments.vue'),
        meta: {
            requiresAuth: true
        }
    },
    // 处理旧的 /professors 路径
    {
        path: '/professors',
        redirect: '/professor/list'
    },
    // 处理 404 情况
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem('token');
    
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        next({ 
            name: 'Login',
            query: { redirect: to.fullPath }
        });
    } else {
        next();
    }
});

export default router;